import { Injectable, Input } from '@angular/core';
import * as SecureLS from 'node_modules/secure-ls/dist/secure-ls';
import { HttpHeaders } from '@angular/common/http';

const ls = new SecureLS({ encodingType: 'aes' });

// NOTE usadas para requisiçoes de login ou especiais como cadastro de participante e convites

export const shortHeader = new HttpHeaders({
  'Content-Type': 'application/json',
  Accept: 'application/json'
});

export const longHeader = new HttpHeaders({
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + sessionStorage.getItem('token'),
  Accept: 'application/json'
});

export const shortDataHeaders = new HttpHeaders({
  Authorization: 'Bearer ' + sessionStorage.getItem('token')
});

@Injectable()
export class APIURL {
  // NOTE Atentar-se a url quando for commitar para produção
  public url = 'http://cidpapi-env.rygzu8a3sd.us-east-2.elasticbeanstalk.com';
  private token: any = ls.get('token').data;

  @Input()
  set DefToken(newToken: any) {
    this.token = newToken;
  }

  public headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + this.token,
    Accept: 'application/json'
  });

  public simpleHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });

  public formDataHeaders = new HttpHeaders({
    Authorization: 'Bearer ' + this.token
  });
}
